import { render, staticRenderFns } from "./DeliveryAddressNewFormContacts.vue?vue&type=template&id=1dd94f56&scoped=true&"
import script from "./DeliveryAddressNewFormContacts.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressNewFormContacts.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddressNewFormContacts.vue?vue&type=style&index=0&id=1dd94f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd94f56",
  null
  
)

export default component.exports